import React from 'react';
import styles from '../../common/utils/styles/css/styles';
import styled, { css } from 'styled-components';
import { Container, MaxWidth } from '../../common/base';
import tinycolor from 'tinycolor2';
import Responsive from '../../common/components/basic/Responsive';

const Highlight = styled.span`
  background-color: ${({ theme: { colors } }) =>
    tinycolor(colors.primary.light)
      .setAlpha(0.5)
      .toString()};
  transition: all ease-in-out 0.2s;

  background-image: linear-gradient(
    to bottom,
    transparent 20%,
    ${({ theme: { colors } }) =>
        tinycolor(colors.primary.primary)
          .setAlpha(0.3)
          .toString()}
      21%
  );

  background-position: 0 95%;
  background-repeat: no-repeat;
  background-size: 0% 120%;

  transition: background-size 0.5s ease-in-out 0.2s;

  :hover {
    background-size: 100% 120%;
    transition-delay: 0s;
  }
`;

export default function Culture() {
  return (
    <Container>
      <div
        css={[
          styles.flex,
          css`
            text-align: justify;
            padding: 80px 0;
            ${MaxWidth.md`
              flex-direction: column-reverse;
            `}
          `
        ]}
      >
        <div css={[styles.flex1]}>
          <h2>Working at RupiahToken</h2>
          <div>
            <p>
              Our version of the great workplace in not comprised of gourmet food, great gyms, fancy
              offices, or frequent parties. Our version of the great workplace is a{' '}
              <Highlight>
                <b>
                  <i>dream team</i>
                </b>{' '}
                in pursuit of ambitious commons goals
              </Highlight>
              , for which we spend heavily. It is on such a team that you learn the most, perform
              you best work, improve the fastest, and have the most fun.
            </p>
            <p css={styles.ptm}>
              We model ourselves on being a <b>team</b>, not a family. A family is about
              unconditional love, despite your siblings' unusual behavior.{' '}
              <Highlight>
                A dream team is about pushing yourself to be the best teammate you can be, caring
                intensely about your teammates, and knowing that you may not be on the team forever
              </Highlight>
              .
            </p>
          </div>
        </div>
        <div css={[styles.flex1, styles.flexMiddle]}>
          <div
            css={css`
              width: 65%;
            `}
          >
            <Responsive ratio={1.1}>
              <img src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/images/culture.png" />
            </Responsive>
          </div>
        </div>
      </div>
    </Container>
  );
}
